// Naturally, we would never want to give a customer a negative discount – because this would increase their
// invoiced amount rather than decreasing it. However, we have a very special case with our customer "PRL Horeca"
// , with which we have signed a contract a very long time ago that we would not give him the discount he is entitled to
// – since that would reward his franchises with lower bills – but instead let them pay the full amount and give him the discount at the end of the year
// – so he can scam himself a lil richer.
export const ALLOWED_NEGATIVE_DISCOUNT_FIELDS = ['discount_amt_per_user']
